import HumanTimeSince from "components/HumanTimeSince"
import React from "react"
import { Button, Dropdown, Grid, Icon, Image, Popup } from "semantic-ui-react"
import { AccountRow } from "./AccountRow"
import NoAccountsRow from "./NoAccountsRow"

export const ConnectionLinks = ({
  name: provider_name,
  logo_url: provider_logo_url,
  accounts,
  refreshLink,
  deleteLink,
  updateCredentials,
  ignoreConnection,
  id,
  unignoreConnection,
  last_refresh_at,
  refresh_status
}) => {
  return (
    <React.Fragment>
      <Grid.Row
        className="ConnectedAccount__Provider"
        columns="equal"
        style={{
          background: "#e5e5e5",
          padding: "0.5em 0.3em"
        }}
      >
        <Grid.Column width="2" verticalAlign="middle" textAlign="center">
          <Image
            centered
            src={provider_logo_url}
            style={{
              maxWidth: "5em",
              maxHeight: "3em"
            }}
          />
        </Grid.Column>
        <Grid.Column width="8" verticalAlign="middle">
          <Popup
            trigger={
              <p>
                {provider_name}{" "}
                {last_refresh_at ? (
                  <span style={{ color: "#888" }}>
                    - refreshed <HumanTimeSince time={last_refresh_at} /> ago{" "}
                  </span>
                ) : null}{" "}
                {refresh_status.indexOf("SUCCESS") < 0 &&
                  refresh_status !== "IN_PROGRESS" && (
                    <Icon
                      name="exclamation triangle"
                      color="red"
                      size="large"
                    />
                  )}
              </p>
            }
            content={
              <p className="greyed-text">
                Refresh Status:{" "}
                {refresh_status
                  .split("_")
                  .join(" ")
                  .toLowerCase()}
              </p>
            }
            basic
          />
        </Grid.Column>
        <Grid.Column textAlign="right" verticalAlign="middle">
          <Button.Group
            color={
              refresh_status.indexOf("SUCCESS") < 0 &&
              refresh_status !== "IN_PROGRESS"
                ? "red"
                : "blue"
            }
            basic
          >
            <Button onClick={() => refreshLink(id)}>Refresh Site</Button>
            <Dropdown floating button className="icon">
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => updateCredentials(id)}>
                  Update Credentials
                </Dropdown.Item>
                <Dropdown.Item onClick={() => deleteLink(id)}>
                  Unlink Site
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Button.Group>
        </Grid.Column>
      </Grid.Row>
      {refresh_status.indexOf("SUCCESS") >= 0 ||
      refresh_status === "IN_PROGRESS" ? (
        accounts.length === 0 ? (
          <NoAccountsRow />
        ) : (
          accounts
            .filter(acc => acc.link_id === id)
            .map(account => (
              <AccountRow
                id={account.id}
                key={account.id}
                ignoreConnection={ignoreConnection}
                unignoreConnection={unignoreConnection}
              />
            ))
        )
      ) : (
        <Grid.Row
          columns="equal"
          className="ConnectedAccount__Row"
          style={{ color: "#ababab" }}
        >
          <Grid.Column textAlign="center">
            Unable to link. Try{" "}
            <span
              className="navlink"
              style={{ cursor: "pointer" }}
              onClick={() => updateCredentials(id)}
            >
              updating credentials.
            </span>
          </Grid.Column>
        </Grid.Row>
      )}
    </React.Fragment>
  )
}
